import { render, staticRenderFns } from "./WalkingNumberUpdate.vue?vue&type=template&id=80fde41e&"
import script from "./WalkingNumberUpdate.vue?vue&type=script&lang=js&"
export * from "./WalkingNumberUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports